import { render } from "./ProprietyBrand.html?vue&type=template&id=1cd1cac4&scoped=true&ts=true"
import script from "./ProprietyBrand.ts?vue&type=script&lang=ts"
export * from "./ProprietyBrand.ts?vue&type=script&lang=ts"

import "./ProprietyBrand.scss?vue&type=style&index=0&id=1cd1cac4&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cd1cac4"]])

export default __exports__